export const heroData = {
  tag: '🔥 今日最热',
  h1: '52吃瓜网 — 全网吃瓜第一站',
  slogan: '最新娱乐八卦、黑料爆料、明星动态，一网打尽',
  description: '52吃瓜网是全网领先的娱乐八卦聚合平台，每日实时追踪娱乐圈最新爆料与黑料动态，覆盖明星恋情、绯闻曝光、综艺争议、影视内幕等热门话题。我们聚合多渠道信源，第一时间整理最全吃瓜资讯，为吃瓜群众提供安全、便捷的八卦浏览入口。无论你是资深瓜友还是刚入圈的吃瓜新人，52吃瓜网都是你不可错过的吃瓜聚集地。当前站内话题涵盖顶流艺人最新动态、热门综艺录制幕后、影视剧争议情节深度解读，每天都有新鲜热乎的瓜等你来吃。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '话题覆盖', value: '50+' },
    { label: '安全访问', value: '全网通' },
  ],
  primaryCta: { text: '立即吃瓜', href: '#cards' },
  secondaryCta: { text: '热度榜单', href: '#ranking' },
};

export const appData = {
  title: 'APP下载',
  subtitle: '随时随地，掌上吃瓜',
  description: '52吃瓜网移动客户端已覆盖 iOS 与 Android 双平台，支持消息推送、离线阅读和夜间模式。下载 APP 即可第一时间接收最新爆料推送，不错过任何一口热瓜。',
  platforms: [
    { name: 'iOS 版', icon: 'ri-apple-fill' },
    { name: 'Android 版', icon: 'ri-android-fill' },
  ],
};

export const commentsData = [
  {
    id: 1,
    avatar: '匿',
    name: '吃瓜不嫌事大',
    time: '2 小时前',
    content: '这个瓜我吃了三天了，越吃越上头！某顶流工作室到现在都没发声明，这态度就很微妙了。坐等后续反转，我先蹲一个。',
    likes: 2847,
    tag: '热评',
  },
  {
    id: 2,
    avatar: '瓜',
    name: '资深瓜农老张',
    time: '5 小时前',
    content: '作为追了这个瓜全程的人，我来补充一下时间线：3月就有路人拍到疑似同框，4月工作室发过含糊声明，现在6月直接实锤了。这波操作我只能说——贵圈真乱。',
    likes: 1932,
    tag: '深度',
  },
  {
    id: 3,
    avatar: '爆',
    name: '今晚不吃鸡',
    time: '8 小时前',
    content: '笑死，隔壁帖子还在洗，这边新料又来了。建议粉丝别急着控评，先看看自家正主干了啥。吃瓜吃到现在，我已经从路人变成这家的吃瓜专业户了。',
    likes: 1503,
    tag: '热议',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '独家：某顶流深夜现身私人会所，同行神秘女子身份成谜',
    duration: '03:25',
    views: '128.6万',
    tag: '独家爆料',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20night%20scene%20outside%20luxury%20club%20entrance%20with%20paparazzi%20style%20blurred%20figures%2C%20dramatic%20lighting%2C%20cinematic%20mood%2C%20mysterious%20atmosphere%2C%20warm%20street%20lamps%20against%20dark%20sky%2C%20entertainment%20news%20aesthetic&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺录制现场冲突画面流出，导演组紧急叫停引猜测',
    duration: '05:12',
    views: '96.3万',
    tag: '现场直击',
    thumbnail: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20lighting%20and%20production%20equipment%2C%20tense%20atmosphere%2C%20crew%20members%20in%20background%2C%20variety%20show%20recording%20scene%2C%20cinematic%20composition%2C%20behind%20the%20scenes%20vibe&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '某当红小花机场私服被扒同款，网友：这审美绝了',
    duration: '02:48',
    views: '85.7万',
    tag: '时尚八卦',
    thumbnail: 'https://readdy.ai/api/search-image?query=Airport%20terminal%20with%20fashionable%20casual%20outfit%20display%2C%20modern%20minimalist%20style%2C%20soft%20natural%20lighting%20through%20large%20windows%2C%20luxury%20shopping%20bags%2C%20editorial%20fashion%20photography%20aesthetic&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-fill',
    title: '极速追踪',
    description: '7×24小时不间断监控娱乐圈动态，热点事件发生30分钟内即可上站，让你永远比朋友圈先吃到瓜。',
  },
  {
    id: 2,
    icon: 'ri-spy-fill',
    title: '独家深扒',
    description: '专业编辑团队深度挖掘事件背景，整理完整时间线与人物关系图，让你吃瓜吃得明明白白。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-fill',
    title: '安全浏览',
    description: '全站 HTTPS 加密传输，无追踪、无弹窗广告，纯净阅读体验。定期更新访问入口，确保稳定可达。',
  },
  {
    id: 4,
    icon: 'ri-group-fill',
    title: '瓜友社群',
    description: '汇聚全网最活跃的吃瓜爱好者，热门话题评论互动，一起分享观点、交换情报，吃瓜路上不孤单。',
  },
];

export const topicsData = [
  { id: 1, name: '顶流恋情曝光', heat: '986万', tag: '爆', color: 'primary' as const },
  { id: 2, name: '综艺录制事故', heat: '753万', tag: '热', color: 'primary' as const },
  { id: 3, name: '女星红毯翻车', heat: '621万', tag: '热', color: 'accent' as const },
  { id: 4, name: '男团内部不和', heat: '518万', tag: '新', color: 'accent' as const },
  { id: 5, name: '导演潜规则爆料', heat: '492万', tag: '爆', color: 'secondary' as const },
  { id: 6, name: '网红人设崩塌', heat: '437万', tag: '热', color: 'primary' as const },
  { id: 7, name: '影视剧删减内幕', heat: '385万', tag: '新', color: 'accent' as const },
  { id: 8, name: '选秀黑幕曝光', heat: '342万', tag: '热', color: 'secondary' as const },
  { id: 9, name: '明星税务风波', heat: '298万', tag: '新', color: 'primary' as const },
  { id: 10, name: '艺人合约纠纷', heat: '256万', tag: '热', color: 'accent' as const },
];

export const indexData = [
  { id: 1, title: '明星恋情追踪', count: 342, icon: 'ri-heart-pulse-line', color: 'primary' as const },
  { id: 2, title: '综艺幕后揭秘', count: 218, icon: 'ri-tv-2-line', color: 'accent' as const },
  { id: 3, title: '影视圈内幕', count: 195, icon: 'ri-film-line', color: 'secondary' as const },
  { id: 4, title: '网红翻车实录', count: 176, icon: 'ri-emotion-normal-line', color: 'primary' as const },
  { id: 5, title: '时尚穿搭八卦', count: 154, icon: 'ri-t-shirt-line', color: 'accent' as const },
  { id: 6, title: '音乐圈大事件', count: 137, icon: 'ri-music-2-line', color: 'secondary' as const },
  { id: 7, title: '选秀节目内幕', count: 121, icon: 'ri-star-line', color: 'primary' as const },
  { id: 8, title: '品牌代言风波', count: 108, icon: 'ri-briefcase-line', color: 'accent' as const },
  { id: 9, title: '海外娱乐速递', count: 95, icon: 'ri-global-line', color: 'secondary' as const },
];

export const carouselData = [
  {
    id: 1,
    title: '某顶流偶像恋情实锤全记录：从暧昧到公开的180天',
    summary: '从年初的路透同框到近日的亲密合影流出，这段顶流恋情经历了多次否认、反复辟谣，最终在铁证面前尘埃落定。本文为你梳理完整时间线与关键节点。',
    tag: '深度追踪',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20night%20city%20scene%20with%20soft%20bokeh%20lights%2C%20elegant%20couple%20silhouette%20in%20distance%2C%20warm%20golden%20and%20pink%20tones%2C%20dreamy%20atmosphere%2C%20entertainment%20magazine%20cover%20aesthetic%2C%20luxurious%20urban%20vibe&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '独家深扒：某热门综艺背后的资本博弈与艺人站队',
    summary: '表面上是综艺效果，背后却是多方利益的暗流涌动。我们独家采访了多位业内人士，揭开这档现象级综艺背后不为人知的制作内幕与艺人间的微妙关系。',
    tag: '独家揭秘',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20set%20with%20spotlight%20and%20silhouettes%2C%20tense%20boardroom%20meeting%20vibe%2C%20dark%20atmosphere%20with%20golden%20accent%20lighting%2C%20cinematic%20behind%20the%20scenes%20look%2C%20high%20contrast%20dramatic%20lighting&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '2024上半年娱乐圈崩盘大盘点：谁在塌房，谁在逆袭',
    summary: '从年初至今，娱乐圈可谓地震不断。我们盘点了上半年最轰动的五大艺人翻车事件，以及那些在风波中逆势翻盘的精彩故事。一起回顾这跌宕起伏的半年。',
    tag: '半年总结',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20scene%20showing%20contrast%20between%20collapse%20and%20rise%2C%20left%20side%20dark%20stormy%20atmosphere%2C%20right%20side%20bright%20golden%20sunrise%2C%20entertainment%20industry%20metaphor%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '从群演到一线：某实力派演员的十年沉浮与圈内规则',
    summary: '他从默默无闻的群演做起，经历过被换角、被雪藏、被网暴，最终凭借一部小成本电影逆天改命。这篇长篇特稿，带你走进他的十年，也走进这个圈子的真实生态。',
    tag: '人物特稿',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20portrait%20of%20a%20performer%20on%20empty%20stage%20with%20dramatic%20single%20spotlight%2C%20showing%20journey%20from%20darkness%20to%20light%2C%20theatrical%20atmosphere%2C%20warm%20spotlight%20against%20deep%20shadows%2C%20emotional%20and%20powerful%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export const faqData = [
  {
    id: 1,
    question: '52吃瓜网的内容来源是什么？',
    answer: '我们的内容来自多渠道公开信息整合，包括社交媒体公开动态、娱乐媒体报道、行业知情人士投稿以及热心瓜友的线索提供。所有内容均经过编辑团队交叉验证后发布。',
  },
  {
    id: 2,
    question: '网站访问不稳定怎么办？',
    answer: '建议收藏本站最新域名并关注我们的社交媒体账号。我们定期更新访问入口，确保瓜友们能够稳定访问。同时推荐下载 APP 客户端，获得更流畅的浏览体验。',
  },
  {
    id: 3,
    question: '如何投稿爆料或提供线索？',
    answer: '欢迎通过页面底部的联系方式向我们投稿。我们承诺对所有投稿人信息严格保密，一经采用还会给予一定的线索奖励。投稿请尽量附带可验证的证据材料。',
  },
  {
    id: 4,
    question: '网站的信息可信度如何？',
    answer: '我们对每一条爆料都进行多源交叉验证，标注信息来源与可信度等级。对于未经证实的信息会明确标注"待核实"，建议瓜友们理性吃瓜，自行判断。',
  },
  {
    id: 5,
    question: '如何第一时间获取最新吃瓜资讯？',
    answer: '推荐下载52吃瓜网 APP 并开启推送通知，关注我们的官方微博和公众号。此外，首页"热门话题"和"最新快讯"模块每小时自动刷新，保证你不错过任何热点。',
  },
  {
    id: 6,
    question: '网站是否需要注册才能浏览？',
    answer: '不需要。52吃瓜网所有内容完全免费开放浏览，无需注册、无需登录。我们坚持做最纯粹的吃瓜平台，让每一位瓜友都能无障碍获取最新娱乐八卦资讯。',
  },
];

export const aboutData = {
  title: '关于52吃瓜网',
  content: '52吃瓜网创立于2018年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为全网吃瓜群众提供最新、最全、最热的娱乐八卦内容。团队核心成员来自主流娱乐媒体和互联网大厂，具备丰富的娱乐资讯采编经验与内容运营能力。经过多年发展，52吃瓜网已成长为日活超百万的头部吃瓜社区，累计服务超过5000万吃瓜爱好者。我们坚持"吃瓜有态度，八卦有底线"的运营理念，在提供精彩内容的同时，始终恪守法律法规和行业规范。',
};

export const updatesData = [
  {
    id: 1,
    time: '15:32',
    title: '某男团队长深夜发文疑似回应恋情传闻',
    summary: '长文提到"感谢大家关心个人生活"，粉丝圈炸开锅',
  },
  {
    id: 2,
    time: '14:18',
    title: '热门综艺节目组发布声明否认剧本造假',
    summary: '称"所有环节均为真实反应"，但网友扒出多处疑点',
  },
  {
    id: 3,
    time: '12:45',
    title: '某女星红毯造型被指抄袭国际大牌设计',
    summary: '造型师连夜发博澄清，称灵感来源于中国传统服饰',
  },
  {
    id: 4,
    time: '10:20',
    title: '知名导演新片选角引发粉丝集体抵制',
    summary: '抵制话题登上热搜，片方暂未回应选角争议',
  },
  {
    id: 5,
    time: '08:55',
    title: '某网红直播间言论翻车，品牌方紧急解约',
    summary: '三小时内五个品牌宣布终止合作，网红账号被限流',
  },
  {
    id: 6,
    time: '昨日 22:10',
    title: '音乐节主办方被曝拖欠艺人出场费',
    summary: '多位参演艺人在社交平台发文催款，主办方回应称正在处理',
  },
  {
    id: 7,
    time: '昨日 19:30',
    title: '古装剧剧组被曝虐待群演，工会介入调查',
    summary: '高温天气连续拍摄16小时，多位群演中暑送医',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '某顶流被拍深夜出入前女友小区，复合传闻再起',
    category: '明星恋情',
    time: '3小时前',
    image: 'https://readdy.ai/api/search-image?query=Night%20residential%20area%20with%20luxury%20apartment%20buildings%2C%20paparazzi%20style%20candid%20shot%2C%20warm%20street%20light%20glow%2C%20mysterious%20night%20atmosphere%2C%20entertainment%20news%20photography%20style&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺录制现场两名艺人发生口角，节目组紧急调解',
    category: '综艺八卦',
    time: '5小时前',
    image: 'https://readdy.ai/api/search-image?query=Tense%20moment%20on%20TV%20variety%20show%20set%2C%20two%20figures%20facing%20off%2C%20production%20crew%20rushing%20in%2C%20dramatic%20studio%20lighting%2C%20behind%20the%20scenes%20chaos%20vibe%2C%20cinematic%20composition&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '某女星素颜逛街被偶遇，真实状态与精修图差距大',
    category: '明星日常',
    time: '7小时前',
    image: 'https://readdy.ai/api/search-image?query=Candid%20street%20photography%20style%2C%20fashionable%20woman%20walking%20in%20shopping%20district%2C%20natural%20daylight%2C%20casual%20outfit%2C%20urban%20street%20scene%2C%20relaxed%20atmosphere%2C%20paparazzi%20style%20shot&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '某古偶剧组男女主疑似因戏生情，片场互动超甜',
    category: '影视八卦',
    time: '9小时前',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20historical%20costume%20drama%20film%20set%2C%20two%20actors%20in%20traditional%20Chinese%20costumes%20sharing%20intimate%20moment%20off%20camera%2C%20warm%20golden%20hour%20lighting%2C%20behind%20the%20scenes%20romance&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '某带货主播被曝虚假宣传，消费者集体维权进行中',
    category: '网红翻车',
    time: '11小时前',
    image: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20setup%20with%20products%20on%20display%2C%20dramatic%20contrast%20lighting%2C%20professional%20streaming%20equipment%2C%20tense%20atmosphere%2C%20modern%20ecommerce%20aesthetic%2C%20behind%20the%20glamour%20reveal&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '知名歌手演唱会假唱实锤？现场观众晒音频对比',
    category: '音乐圈',
    time: '13小时前',
    image: 'https://readdy.ai/api/search-image?query=Large%20concert%20stage%20with%20dramatic%20purple%20and%20golden%20stage%20lighting%2C%20massive%20crowd%20silhouettes%2C%20spotlight%20on%20empty%20microphone%20stand%2C%20emotional%20atmosphere%2C%20live%20music%20performance%20aesthetic&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    id: 7,
    title: '某经纪公司内部邮件泄露，艺人收入分成比例曝光',
    category: '行业爆料',
    time: '15小时前',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20office%20scene%20with%20scattered%20documents%20on%20desk%2C%20dramatic%20shadows%20and%20light%2C%20confidential%20business%20atmosphere%2C%20modern%20minimalist%20office%20with%20tension%2C%20cinematic%20lighting&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '顶流偶像新恋情曝光，女方身份引全网猜测', heat: '1,286万', trend: 'up' as const },
  { id: 2, rank: 2, title: '某综艺节目录制现场意外，导演组发声明道歉', heat: '1,053万', trend: 'up' as const },
  { id: 3, rank: 3, title: '当红小花红毯造型翻车，造型师被粉丝围攻', heat: '987万', trend: 'down' as const },
  { id: 4, rank: 4, title: '一线男星被曝税务问题，工作室紧急回应', heat: '892万', trend: 'up' as const },
  { id: 5, rank: 5, title: '知名导演新片票房惨败，投资人血本无归', heat: '765万', trend: 'up' as const },
  { id: 6, rank: 6, title: '某女团成员退队内幕：与经纪公司合约纠纷', heat: '654万', trend: 'down' as const },
  { id: 7, rank: 7, title: '网红夫妇离婚大战升级，互爆黑料停不下来', heat: '543万', trend: 'up' as const },
];

export const contactData = {
  title: '联系我们',
  subtitle: '有料你就来，一起吃瓜一起嗨',
  description: '欢迎投稿爆料、商务合作或提供线索。我们承诺对所有来信严格保密，优质线索一经采用即付丰厚稿酬。',
  email: 'tips@52chigua.com',
  channels: [
    { name: '投稿爆料', icon: 'ri-mail-send-line', desc: '发送邮件至投稿邮箱，附上证据材料' },
    { name: '商务合作', icon: 'ri-briefcase-4-line', desc: '品牌推广、广告投放等商业合作咨询' },
    { name: '用户反馈', icon: 'ri-feedback-line', desc: '网站问题反馈、功能建议与意见' },
  ],
};